export { default as ShopToClub } from './Registration';
export { default as ShopToClubDoubleOptIn } from './DoubleOptIn';
